export const EMAIL_ADDRESS_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i;

const MAX_LENGTH = 254; // Limit defined by SMTP protocols

/**
 * @param {unknown} raw
 * @returns {boolean}
 */
export function isValidEmailAddress(raw) {
    if (raw == null) return false;
    const trimmed = String(raw).trim();
    if (trimmed.includes('..') || trimmed.includes('@.') || trimmed.includes('.@')) return false;
    if (!trimmed || trimmed.length > MAX_LENGTH) return false;
    return EMAIL_ADDRESS_REGEX.test(trimmed);
}
